// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { handleError } from '@tectonics/alert-handler';

import amexImageSrc from './images/credit-card-amex.svg';
import mastercardImageSrc from './images/credit-card-mastercard.svg';
import visaImageSrc from './images/credit-card-visa.svg';
import magnaImageSrc from './images/credit-card-magna.svg';

export function DisplayWebpayBrands(): Node {
  const brandsToDisplay = ['mastercard', 'visa', 'amex', 'magna'];

  return (
    <Root>
      {brandsToDisplay.map(brand => (
        <WebpayImageWrapper key={brand}>
          <WebpayBrandImage src={getWebpayBrandImageSrc(brand)} alt={brand} />
        </WebpayImageWrapper>
      ))}
    </Root>
  );
}

const Root = styled.div`
  height: 100%;
  display: flex;
`;

const WebpayImageWrapper = styled.div`
  flex-grow: 1;
  padding-left: 4px;
`;

const WebpayBrandImage = styled.img`
  height: 100%;
  width: 100%;
`;

function getWebpayBrandImageSrc(webpayBrand: string): string {
  switch (webpayBrand) {
    case 'amex':
      return amexImageSrc;

    case 'mastercard':
      return mastercardImageSrc;

    case 'visa':
      return visaImageSrc;

    case 'magna':
      return magnaImageSrc;

    default: {
      handleError(new Error(`Display webpay brand: there is no source for "${webpayBrand}"`));
      return '';
    }
  }
}
